import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GrossQuantityWiseBagCount } from './Pages';

export const GrossQuantityWiseBagCountRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={GrossQuantityWiseBagCount} />
    </Fragment>
)